import React, { useState } from 'react';
import { Button } from '../ui/button';
import { FeatherXCircle } from '../ui/icons';
import './ProjectForm.css';

const ProjectForm = ({ onSuccess, onCancel }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        abbreviation: '',
        status: 'active'
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSuccess(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="project-form">
            <div className="form-group">
                <label htmlFor="name" className="form-label">
                    Project Name
                </label>
                <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="form-input"
                    required
                    placeholder="Enter project name"
                />
            </div>

            <div className="form-group">
                <label htmlFor="description" className="form-label">
                    Description
                </label>
                <textarea
                    id="description"
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    className="form-textarea"
                    rows="4"
                    placeholder="Enter project description"
                />
            </div>

            <div className="form-group">
                <label htmlFor="abbreviation" className="form-label">
                    Project Abbreviation
                    <span className="form-help">(Optional - will be auto-generated if not provided)</span>
                </label>
                <input
                    type="text"
                    id="abbreviation"
                    value={formData.abbreviation}
                    onChange={(e) => setFormData({ ...formData, abbreviation: e.target.value.toUpperCase() })}
                    className="form-input"
                    placeholder="e.g., CP, PORTAL, APP"
                    maxLength="6"
                    pattern="[A-Z0-9]+"
                    title="2-6 uppercase letters and numbers only"
                />
                <div className="form-preview">
                    {formData.abbreviation && (
                        <span className="preview-text">
                            Task IDs will be: {formData.abbreviation}-0001, {formData.abbreviation}-0002, etc.
                        </span>
                    )}
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="status" className="form-label">
                    Status
                </label>
                <select
                    id="status"
                    value={formData.status}
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                    className="form-select"
                >
                    <option value="active">Active</option>
                    <option value="completed">Completed</option>
                    <option value="on-hold">On Hold</option>
                </select>
            </div>

            <div className="form-actions">
                <Button
                    type="button"
                    variant="neutral-tertiary"
                    icon={<FeatherXCircle />}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    variant="brand-primary"
                >
                    Create Project
                </Button>
            </div>
        </form>
    );
};

export default ProjectForm; 